class CollageSlideshow extends HTMLElement {
  constructor() {
    super();

    this.slide = this.querySelector('.js-collage-slideshow');
    this.swiperSlide = this.querySelectorAll('.js-collage-slideshow .swiper-slide');
      new Swiper(this.slide, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 600,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          810: {
            slidesPerView: 2.8,
            spaceBetween: 16,
          },
        },
      });
  }
}
customElements.define("collage-slideshow", CollageSlideshow)